import { FC } from 'react';
import ReserveFrameEdit from './ReserveFrameEdit';
import UseReserveFrameEdit from './UseReserveFrameEdit';

const ReserveFrameEditContainer: FC = () => {
  return <ReserveFrameEdit {...UseReserveFrameEdit()} />;
};

export default ReserveFrameEditContainer;
